var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69785 15.655V10.655H11.6979V15.655C11.6979 16.205 12.1479 16.655 12.6979 16.655H15.6979C16.2479 16.655 16.6979 16.205 16.6979 15.655V8.655H18.3979C18.8579 8.655 19.0779 8.085 18.7279 7.785L10.3679 0.255C9.98785 -0.085 9.40785 -0.085 9.02785 0.255L0.667852 7.785C0.327852 8.085 0.537852 8.655 0.997852 8.655H2.69785V15.655C2.69785 16.205 3.14785 16.655 3.69785 16.655H6.69785C7.24785 16.655 7.69785 16.205 7.69785 15.655Z",
    fill: "#828788"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.b3ff6187ea85fe726ed34de5544a048c.svg";
export { ForwardRef as ReactComponent };